var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-164"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.59,260.91c-87.61-50.58-229.17-50.58-316.21,0s-86.57,132.58,1,183.16,229.17,50.58,316.21,0S495.19,311.49,407.59,260.91Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-164"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.22,387.45c22.65,13.08,22.77,34.28.27,47.36s-59.11,13.08-81.77,0-22.77-34.28-.26-47.36S325.57,374.37,348.22,387.45Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.54,352.94c16.81,9.7,44,9.7,60.69,0,8.35-4.86,12.5-11.22,12.46-17.58s-4.26-12.72-12.66-17.58c-16.82-9.7-44-9.7-60.69,0-8.35,4.86-12.5,11.22-12.47,17.58S358.13,348.08,366.54,352.94Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9,371.59c9.79,5.66,25.62,5.66,35.34,0,4.87-2.82,7.29-6.53,7.27-10.23s-2.48-7.42-7.38-10.24c-9.79-5.66-25.62-5.66-35.35,0-4.86,2.82-7.28,6.53-7.26,10.24S45,368.77,49.9,371.59Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.35,393.26l5.65,3.3a4.14,4.14,0,0,0,4.13,0l154.56-88.21a1,1,0,0,0,0-1.78l-5.66-3.3a4.1,4.1,0,0,0-4.12,0L86.36,391.47A1,1,0,0,0,86.35,393.26Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Windows--inject-164"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "286.64 65.04 290.12 63.02 326.85 84.15 326.85 88.17 286.64 65.04",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.64 65.04 286.64 65.04 286.64 65.04 326.85 88.17 326.85 92.75 286.63 69.65 286.64 65.04",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.75,
    y: 53.41,
    height: 46.39,
    transform: "translate(87.41 304.31) rotate(-60.09)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.85 100.25 351.33 98.23 388.06 119.36 388.06 123.38 347.85 100.25",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.85 100.25 347.85 100.25 347.85 100.25 388.06 123.38 388.06 127.97 347.84 104.86 347.85 100.25",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.96,
    y: 88.62,
    height: 46.39,
    transform: "translate(87.57 375.02) rotate(-60.09)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.06 135.47 412.54 133.44 449.27 154.57 449.27 158.59 409.06 135.47",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.06 135.47 409.06 135.47 409.06 135.47 449.27 158.59 449.27 163.18 409.05 140.08 409.06 135.47",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.17,
    y: 123.84,
    height: 46.39,
    transform: "translate(87.74 445.74) rotate(-60.09)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.84 26.43 290.31 24.41 290.11 128.43 286.63 130.44 286.84 26.43",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.63 130.44 290.11 128.43 330.12 151.39 326.65 153.41 286.63 130.44",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.85,19.52l48,27.59-.23,113.21-48-27.59Zm43.8,133.89.2-104-40-23-.21,104,40,23",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.85 19.52 286.33 17.5 334.34 45.09 330.86 47.11 282.85 19.52",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.86 47.11 334.34 45.09 334.11 158.3 330.63 160.32 330.86 47.11",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.05 61.64 351.52 59.62 351.32 163.64 347.84 165.66 348.05 61.64",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.84 165.66 351.32 163.64 391.33 186.61 387.86 188.63 347.84 165.66",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.06,54.74l48,27.58-.23,113.21-48-27.58Zm43.8,133.89.2-104-40-23-.21,104,40,23",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.06 54.74 347.54 52.72 395.55 80.31 392.07 82.33 344.06 54.74",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.07 82.33 395.55 80.31 395.32 193.51 391.84 195.53 392.07 82.33",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.26 96.86 412.73 94.84 412.53 198.85 409.05 200.87 409.26 96.86",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.05 200.87 412.53 198.85 452.54 221.82 449.07 223.84 409.05 200.87",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.27,90l48,27.59-.23,113.21-48-27.59Zm43.8,133.89.2-104-40-23-.21,104,40,23",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.27 89.95 408.75 87.93 456.76 115.52 453.28 117.54 405.27 89.95",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "453.28 117.54 456.76 115.52 456.53 228.73 453.05 230.75 453.28 117.54",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-164"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.45,328.29l-19,.55-19-.55c-.82,12.82,1.68,25.88,5.13,32.26h0a8.62,8.62,0,0,0,3.76,3.82c5.6,3.23,14.65,3.23,20.22,0a8.35,8.35,0,0,0,3.75-3.92C83.78,354,86.26,341,85.45,328.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.84,320.52c7.44,4.29,7.48,11.25.09,15.54s-19.4,4.3-26.84,0-7.48-11.25-.09-15.54S72.41,316.22,79.84,320.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9,322.22c5.8,3.35,5.83,8.79.07,12.13s-15.14,3.35-20.94,0-5.83-8.78-.07-12.13S71.1,318.88,76.9,322.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.9,322.22c5.8,3.35,5.83,8.79.07,12.13s-15.14,3.35-20.94,0-5.83-8.78-.07-12.13S71.1,318.88,76.9,322.22Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M97.67,247.3c-42.77,14-43.16,42.62-33.52,63,2.44,4.12,9.8,6.34,16.2-19l-11.23,1.44,13.09-6.63,3.4-10.17-10.92.81,13.86-5.83A203.8,203.8,0,0,1,97.67,247.3Z",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.67,247.3c-42.77,14-43.16,42.62-33.52,63,2.44,4.12,9.8,6.34,16.2-19l-11.23,1.44,13.09-6.63,3.4-10.17-10.92.81,13.86-5.83A203.8,203.8,0,0,1,97.67,247.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.57,254.45C63,271.57,61,291.2,67.35,311.69,65.1,293.65,62.66,275.41,85.57,254.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.23,276.37c42.16,5.93,47.27,32.52,41.68,53.1-1.58,4.24-8.07,7.53-18.24-15l10.7-.53-13.3-4L41.22,301,51.52,300l-13.87-3.13A193.37,193.37,0,0,0,25.23,276.37Z",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.23,276.37c42.16,5.93,47.27,32.52,41.68,53.1-1.58,4.24-8.07,7.53-18.24-15l10.7-.53-13.3-4L41.22,301,51.52,300l-13.87-3.13A193.37,193.37,0,0,0,25.23,276.37Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.68,281c23.85,12.2,29,30.14,26.48,50.28C63.26,314.12,62.5,296.73,37.68,281Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,286.33c-38.66.63-46.25,24-43.51,43.19,1,4,6.43,7.69,18.12-11.48L75,316.37l12.44-2.12,5.37-7.48-9.17-2.11,12.86-1.26A176.33,176.33,0,0,1,110,286.33Z",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.26,289.13C75.4,297.45,68.75,313,68.77,331.48,71.5,316.1,74.14,300.51,98.26,289.13Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-164"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394,297.72c.27,29.88.59,58.65.59,58.65a1.07,1.07,0,0,0,.64.89,3.41,3.41,0,0,0,3.08,0,1.08,1.08,0,0,0,.63-.89s.32-28.76.59-58.64C397.71,297.8,395.86,297.8,394,297.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.71,334.82a1.08,1.08,0,0,0,.64.89,3.41,3.41,0,0,0,3.08,0,1.09,1.09,0,0,0,.63-.89s1.39-20.55,3.37-45a32.82,32.82,0,0,1-5.21-4C358.62,312,357.71,334.82,357.71,334.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.51,334.82a1.09,1.09,0,0,0,.63.89,3.41,3.41,0,0,0,3.08,0,1.11,1.11,0,0,0,.64-.89S435,312.09,433.35,286a32.89,32.89,0,0,1-5.21,3.95C430.13,314.33,431.51,334.82,431.51,334.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,297.72c.27,29.88.59,58.65.59,58.65a1.07,1.07,0,0,0,.64.89,3.41,3.41,0,0,0,3.08,0,1.08,1.08,0,0,0,.63-.89s.32-28.76.59-58.64C397.71,297.8,395.86,297.8,394,297.72Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.71,334.82a1.08,1.08,0,0,0,.64.89,3.41,3.41,0,0,0,3.08,0,1.09,1.09,0,0,0,.63-.89s1.39-20.55,3.37-45a32.82,32.82,0,0,1-5.21-4C358.62,312,357.71,334.82,357.71,334.82Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.51,334.82a1.09,1.09,0,0,0,.63.89,3.41,3.41,0,0,0,3.08,0,1.11,1.11,0,0,0,.64-.89S435,312.09,433.35,286a32.89,32.89,0,0,1-5.21,3.95C430.13,314.33,431.51,334.82,431.51,334.82Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.69,268.1c0,6.36-4.11,12.72-12.46,17.57-16.71,9.71-43.88,9.71-60.69,0-8.41-4.85-12.63-11.21-12.67-17.57h0v4.83c0,4.49,2.15,9,6.35,12.94a32.82,32.82,0,0,0,5.21,4l1.11.67c7.66,4.42,17.48,6.82,27.48,7.21,1.84.08,3.69.08,5.53,0,10.09-.35,20-2.76,27.68-7.22l.91-.56a32.89,32.89,0,0,0,5.21-3.95c4.25-4,6.37-8.53,6.34-13.07h0V268.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.69,268.1c0,6.36-4.11,12.72-12.46,17.57-16.71,9.71-43.88,9.71-60.69,0-8.41-4.85-12.63-11.21-12.67-17.57h0v4.83c0,4.49,2.15,9,6.35,12.94a32.82,32.82,0,0,0,5.21,4l1.11.67c7.66,4.42,17.48,6.82,27.48,7.21,1.84.08,3.69.08,5.53,0,10.09-.35,20-2.76,27.68-7.22l.91-.56a32.89,32.89,0,0,0,5.21-3.95c4.25-4,6.37-8.53,6.34-13.07h0V268.1Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.54,285.67c16.81,9.71,44,9.71,60.69,0,8.35-4.85,12.5-11.21,12.46-17.57s-4.26-12.72-12.66-17.58c-16.82-9.7-44-9.7-60.69,0-8.35,4.86-12.5,11.22-12.47,17.58S358.13,280.82,366.54,285.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M394,297.72c0,2,0,4,.05,6,1.81.07,3.62.07,5.43,0,0-2,0-4,.05-6C397.71,297.8,395.86,297.8,394,297.72Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M360.22,285.87c-.11,1.91-.23,3.8-.34,5.66a31.94,31.94,0,0,0,5.1,4c.14-1.87.3-3.77.45-5.69A32.82,32.82,0,0,1,360.22,285.87Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M433.35,286a32.89,32.89,0,0,1-5.21,3.95q.24,2.88.46,5.69a31.78,31.78,0,0,0,5.09-4C433.58,289.8,433.47,287.91,433.35,286Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394,297.72c.27,29.88.59,58.65.59,58.65a1.07,1.07,0,0,0,.64.89,3.41,3.41,0,0,0,3.08,0,1.08,1.08,0,0,0,.63-.89s.32-28.76.59-58.64C397.71,297.8,395.86,297.8,394,297.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.71,334.82a1.08,1.08,0,0,0,.64.89,3.41,3.41,0,0,0,3.08,0,1.09,1.09,0,0,0,.63-.89s1.39-20.55,3.37-45a32.82,32.82,0,0,1-5.21-4C358.62,312,357.71,334.82,357.71,334.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.51,334.82a1.09,1.09,0,0,0,.63.89,3.41,3.41,0,0,0,3.08,0,1.11,1.11,0,0,0,.64-.89S435,312.09,433.35,286a32.89,32.89,0,0,1-5.21,3.95C430.13,314.33,431.51,334.82,431.51,334.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.69,268.1c0,6.36-4.11,12.72-12.46,17.57-16.71,9.71-43.88,9.71-60.69,0-8.41-4.85-12.63-11.21-12.67-17.57h0v4.83c0,4.49,2.15,9,6.35,12.94a32.82,32.82,0,0,0,5.21,4l1.11.67c7.66,4.42,17.48,6.82,27.48,7.21,1.84.08,3.69.08,5.53,0,10.09-.35,20-2.76,27.68-7.22l.91-.56a32.89,32.89,0,0,0,5.21-3.95c4.25-4,6.37-8.53,6.34-13.07h0V268.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.54,285.67c16.81,9.71,44,9.71,60.69,0,8.35-4.85,12.5-11.21,12.46-17.57s-4.26-12.72-12.66-17.58c-16.82-9.7-44-9.7-60.69,0-8.35,4.86-12.5,11.22-12.47,17.58S358.13,280.82,366.54,285.67Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M411.16,241.59,396.7,242l-14.46-.42c-.62,9.76,1.28,19.72,3.91,24.58h0a6.61,6.61,0,0,0,2.86,2.91,17,17,0,0,0,15.41,0,6.39,6.39,0,0,0,2.86-3C409.9,261.2,411.78,251.3,411.16,241.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.89,235.66c5.67,3.27,5.7,8.58.07,11.85s-14.79,3.27-20.45,0-5.7-8.57-.07-11.85S401.23,232.39,406.89,235.66Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.65,237c4.42,2.55,4.45,6.69.05,9.24s-11.53,2.55-15.95,0-4.45-6.69-.05-9.24S400.23,234.41,404.65,237Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M404.65,237c4.42,2.55,4.45,6.69.05,9.24s-11.53,2.55-15.95,0-4.45-6.69-.05-9.24S400.23,234.41,404.65,237Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M395.49,242a9.56,9.56,0,0,0,8.49,1.92,8.87,8.87,0,0,0,5.94-6,17.34,17.34,0,0,1-4.64-3.22,12,12,0,0,1,6.57.23,6.69,6.69,0,0,0,.5-6.26,11.51,11.51,0,0,0-7.84-.55,10.42,10.42,0,0,1,7.92-2.5,30.38,30.38,0,0,0-1.9-12.17c-5.39.28-10.62,2.6-12.38,4.27a19.65,19.65,0,0,0,.6,5.73,4.63,4.63,0,0,1-2.51-3.7c-3.37.84-4.82,2.52-5.34,3.81a14,14,0,0,0,3.19,6.47c-3.17-1-4.45-4.49-4.45-4.49C386.52,232.92,387.12,241.28,395.49,242Z",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.49,242a9.56,9.56,0,0,0,8.49,1.92,8.87,8.87,0,0,0,5.94-6,17.34,17.34,0,0,1-4.64-3.22,12,12,0,0,1,6.57.23,6.69,6.69,0,0,0,.5-6.26,11.51,11.51,0,0,0-7.84-.55,10.42,10.42,0,0,1,7.92-2.5,30.38,30.38,0,0,0-1.9-12.17c-5.39.28-10.62,2.6-12.38,4.27a19.65,19.65,0,0,0,.6,5.73,4.63,4.63,0,0,1-2.51-3.7c-3.37.84-4.82,2.52-5.34,3.81a14,14,0,0,0,3.19,6.47c-3.17-1-4.45-4.49-4.45-4.49C386.52,232.92,387.12,241.28,395.49,242Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.49,242a9.56,9.56,0,0,0,8.49,1.92,8.87,8.87,0,0,0,5.94-6,17.34,17.34,0,0,1-4.64-3.22,12,12,0,0,1,6.57.23,6.69,6.69,0,0,0,.5-6.26,11.51,11.51,0,0,0-7.84-.55,10.42,10.42,0,0,1,7.92-2.5,30.38,30.38,0,0,0-1.9-12.17c-5.39.28-10.62,2.6-12.38,4.27a19.65,19.65,0,0,0,.6,5.73,4.63,4.63,0,0,1-2.51-3.7c-3.37.84-4.82,2.52-5.34,3.81a14,14,0,0,0,3.19,6.47c-3.17-1-4.45-4.49-4.45-4.49C386.52,232.92,387.12,241.28,395.49,242Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.31,242.8h0a.31.31,0,0,1-.29-.33c.52-6.81,4.41-18.05,13.7-27.32a.31.31,0,0,1,.44.44c-9.16,9.15-13,20.22-13.51,26.93A.32.32,0,0,1,395.31,242.8Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.85,245.64A8.85,8.85,0,0,1,384,242a15,15,0,0,0,4.19-2.85,11.89,11.89,0,0,0-6.21.18,5.77,5.77,0,0,1-.87-5.59,11.39,11.39,0,0,1,7.4-.44,11,11,0,0,0-7.68-2.28,24.71,24.71,0,0,1,1-10.87c5.13.31,10.22,2.44,12,3.95a16.34,16.34,0,0,1-.21,5.08,3.73,3.73,0,0,0,2.13-3.27c3.22.78,4.67,2.29,5.24,3.43a11.24,11.24,0,0,1-2.59,5.71,6.38,6.38,0,0,0,3.89-3.94C405.68,237.65,405.63,245,397.85,245.64Z",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.85,245.64A8.85,8.85,0,0,1,384,242a15,15,0,0,0,4.19-2.85,11.89,11.89,0,0,0-6.21.18,5.77,5.77,0,0,1-.87-5.59,11.39,11.39,0,0,1,7.4-.44,11,11,0,0,0-7.68-2.28,24.71,24.71,0,0,1,1-10.87c5.13.31,10.22,2.44,12,3.95a16.34,16.34,0,0,1-.21,5.08,3.73,3.73,0,0,0,2.13-3.27c3.22.78,4.67,2.29,5.24,3.43a11.24,11.24,0,0,1-2.59,5.71,6.38,6.38,0,0,0,3.89-3.94C405.68,237.65,405.63,245,397.85,245.64Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.06,246.38a.32.32,0,0,1-.31-.26c-.88-5.93-5.19-15.77-14.42-24a.31.31,0,0,1,0-.44.31.31,0,0,1,.44,0C393.1,230,397.47,240,398.37,246a.32.32,0,0,1-.26.36Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-164"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.73,39.94h0a9.26,9.26,0,0,0-1-2.41c-1-1.5-2.67-2.38-6.71-2.3a5.16,5.16,0,0,0-1.65.33L90.55,121.93a11.1,11.1,0,0,0-5.53,9.5V378.49c0,4.41,2.59,6.07,5.47,6.26a10.25,10.25,0,0,0,3.66-.47l0,0a2.65,2.65,0,0,0,.44-.17L246.5,297.59a10.94,10.94,0,0,0,5.52-9.5v-247A2.75,2.75,0,0,0,251.73,39.94Z",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.73,39.94h0a9.26,9.26,0,0,0-1-2.41c-1-1.5-2.67-2.38-6.71-2.3a5.16,5.16,0,0,0-1.65.33L90.55,121.93a11.1,11.1,0,0,0-5.53,9.5V378.49c0,4.41,2.59,6.07,5.47,6.26a10.25,10.25,0,0,0,3.66-.47l0,0a2.65,2.65,0,0,0,.44-.17L246.5,297.59a10.94,10.94,0,0,0,5.52-9.5v-247A2.75,2.75,0,0,0,251.73,39.94Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.16,126.63a10.91,10.91,0,0,0-1.14,4.8V378.49c0,4.41,2.59,6.07,5.47,6.26a6.8,6.8,0,0,1-1.11-4.05V133.63a10.89,10.89,0,0,1,1.13-4.79c.12-.25.28-.48.42-.72l-4.22-2.44C86.52,126,86.32,126.3,86.16,126.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.06,35.23a5.16,5.16,0,0,0-1.65.33L90.55,121.93a10.79,10.79,0,0,0-3.84,3.75l4.22,2.44a10.83,10.83,0,0,1,4-4L246.76,37.76a5.41,5.41,0,0,1,1.65-.32,18.92,18.92,0,0,1,2.36.09C249.82,36,248.1,35.15,244.06,35.23Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.09 47.66 96.6 133.36 96.6 366.33 245.09 280.63 245.09 47.66",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.47,323a12.47,12.47,0,0,0-5.61,8.08c-.37,2.88,1.54,4,4.28,2.37a12.54,12.54,0,0,0,5.61-8.08C183.11,322.5,181.2,321.43,178.47,323Z",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.47,323a12.47,12.47,0,0,0-5.61,8.08c-.37,2.88,1.54,4,4.28,2.37a12.54,12.54,0,0,0,5.61-8.08C183.11,322.5,181.2,321.43,178.47,323Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-164"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.36,35.46V27.9a2.39,2.39,0,0,0-.25-1h0a7.45,7.45,0,0,0-.85-2.11c-.83-1.33-2.35-2.1-5.91-2a4.54,4.54,0,0,0-1.45.28L117.14,99.06a9.77,9.77,0,0,0-4.86,8.36v8.66l3.83,2.21Z",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.11,118.29l-3.83-2.21V332.59c0,3.88,2.28,5.35,4.81,5.51a9,9,0,0,0,3.23-.41l0,0a3.2,3.2,0,0,0,.39-.16L254.5,261.33a9.61,9.61,0,0,0,4.86-8.36V35.46Z",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.28,103.2a9.53,9.53,0,0,0-1,4.22V332.59c0,3.88,2.28,5.35,4.81,5.51a6,6,0,0,1-1-3.57V109.37a9.63,9.63,0,0,1,1-4.22c.11-.22.25-.43.37-.64l-3.72-2.14A8.52,8.52,0,0,0,113.28,103.2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.35,22.7a4.54,4.54,0,0,0-1.45.28L117.14,99.06a9.49,9.49,0,0,0-3.38,3.31l3.72,2.14A9.58,9.58,0,0,1,121,101L254.73,24.93a4.37,4.37,0,0,1,1.46-.28,14.66,14.66,0,0,1,2.07.08C257.43,23.4,255.91,22.63,252.35,22.7Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.36,35.46V27.9a2.39,2.39,0,0,0-.25-1h0a7.45,7.45,0,0,0-.85-2.11c-.83-1.33-2.35-2.1-5.91-2a4.54,4.54,0,0,0-1.45.28L117.14,99.06a9.77,9.77,0,0,0-4.86,8.36v8.66l3.83,2.21Z",
    style: {
      fill: "#fff",
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.11,118.29l-3.83-2.21V332.59c0,3.88,2.28,5.35,4.81,5.51a9,9,0,0,0,3.23-.41l0,0a3.2,3.2,0,0,0,.39-.16L254.5,261.33a9.61,9.61,0,0,0,4.86-8.36V35.46Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.16 114.43 127.35 148.36 127.35 246.55 186.16 212.61 186.16 114.43",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.62 150.25 182.9 120.08 182.9 210.73 130.62 240.89 130.62 150.25",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.62 150.25 182.9 120.08 182.9 210.73 130.62 240.89 130.62 150.25",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.9,210.8,130.62,241V206.29l15.21-11.95,19.6-7.44,4.85-1.21a15.38,15.38,0,0,1,12.62,2.37h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.71,185.54Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.45,168c-1.52-5.09-1.19-10.93,1.85-15.29a16.67,16.67,0,0,1,8.06-6,25.68,25.68,0,0,1,10-1.3,18.41,18.41,0,0,1,7.74,1.87,12.46,12.46,0,0,1,5.12,16.88,20.88,20.88,0,0,1-5.07,5.78,64.31,64.31,0,0,1-12.77,8.52c-1.14.58-2.3,1.13-3.48,1.64-.8.35-2.31,1.33-3.21,1.15s-1.84-1.85-2.38-2.54c-.78-1-1.52-2-2.21-3.06A29.2,29.2,0,0,1,142.45,168Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.76,210.75a25.22,25.22,0,0,0-1.56-4.46l-2.5.59c.19,1.4.29,2.86.34,4.31,0,1-.08,4.7-.27,9.49l5.61-3.23C170.88,215.25,170.35,213,169.76,210.75Z",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.76,207.41c0-.17,0-.35-.06-.53l2.5-.59.15.37a2.89,2.89,0,0,1-2.59.75Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.36,200.33l-2-1.26-4.58,2.5a10.59,10.59,0,0,0,5.41,2.14Z",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.4,199.85l.6-1.35,2.31,1.45a4.18,4.18,0,0,1-1.5,2.2Z",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.36,200.33l-2-1.26-4.58,2.5a10.59,10.59,0,0,0,5.41,2.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.4,199.85l.6-1.35,2.31,1.45a4.18,4.18,0,0,1-1.5,2.2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.22,203.71a11,11,0,0,1,1.14-3.38l3-.48a12,12,0,0,1,1.41,2.3,10.91,10.91,0,0,1-.61,4.14,5.32,5.32,0,0,1-2.5.59A6.58,6.58,0,0,1,163.22,203.71Z",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.38,176.86v13.88c2.76,3.81,14.37,8.64,15.05,8.53.84-.15,0-7.63,0-8.28v-5.62c-2.26-.34-4.47-.74-6.46-1.16A11.72,11.72,0,0,1,150.38,176.86Z",
    style: {
      fill: "#9c5c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.38,187.5a31.79,31.79,0,0,0,5.05.9v-3c-2.26-.34-4.47-.74-6.46-1.16a11.73,11.73,0,0,1-8.3-6.7,12.08,12.08,0,0,0,3,6.26A14.35,14.35,0,0,0,160.38,187.5Z",
    style: {
      fill: "#803e3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.1,155a12.67,12.67,0,0,1-8.45,3.56c-3,0-5.84-.95-8.71-1.74a6.67,6.67,0,0,1-2,3.64,7.63,7.63,0,0,1-4.05,1.77,26.13,26.13,0,0,1,0,8.09,1.55,1.55,0,0,1-1,1.25c-1,.28-1.6-.71-2.07-1.51a6.66,6.66,0,0,0-2.1-2.34,3.28,3.28,0,0,0-3-.31,3.21,3.21,0,0,0-1.6,2,6,6,0,0,0-.12,2.56,7.66,7.66,0,0,0,1.66,3.92,5.29,5.29,0,0,0,3.73,1.93,3.85,3.85,0,0,0,3.58-1.77l.07.26a10.76,10.76,0,0,0,8.21,8c1.82.38,3.84.74,5.89,1.06,1,.15,2,.29,3,.41a7.34,7.34,0,0,0,8.1-6C176.61,171.87,177.07,162.75,174.1,155Z",
    style: {
      fill: "#9c5c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.18,164.89h-1.76a12.93,12.93,0,0,0-12.19-1.25v1.86l.49.26a19.28,19.28,0,0,1,.45,3.65,4.86,4.86,0,0,0,1.35,3.23,5.53,5.53,0,0,0,3.62.94,6.84,6.84,0,0,0,3-.44,4.83,4.83,0,0,0,2.3-2.76c.44-1.16.36-1.83.9-3.22a1,1,0,0,1,1-.65,1,1,0,0,1,.9.65c.5,1.39.44,2.06.84,3.22a4.83,4.83,0,0,0,2.15,2.76,6,6,0,0,0,2.83.44,4.93,4.93,0,0,0,3.39-.94,5,5,0,0,0,1.26-3.23,20.1,20.1,0,0,1,.42-3.65l.46-.26v-1.86A11.43,11.43,0,0,0,168.18,164.89Zm-2.65,1-.07.66a15.86,15.86,0,0,1-.89,3.51,4,4,0,0,1-1.82,2.22,5.09,5.09,0,0,1-2.17.35h-.4a4.61,4.61,0,0,1-3-.72,3.76,3.76,0,0,1-1-2.59c0-.31-.06-.63-.08-1-.06-.89,0-2.83.07-4.24a11.57,11.57,0,0,1,3.09-.42,11.73,11.73,0,0,1,6.21,1.81C165.56,165.53,165.53,165.84,165.53,165.84Zm12.32,2.48c0,.32,0,.64-.07,1a3.9,3.9,0,0,1-1,2.59,4.09,4.09,0,0,1-2.8.72h-.37a4.47,4.47,0,0,1-2-.35,3.9,3.9,0,0,1-1.7-2.22,16.62,16.62,0,0,1-.83-3.51l-.07-.66s0-.31.07-.37a10.47,10.47,0,0,1,5.81-1.81,10.1,10.1,0,0,1,2.89.42C177.86,165.49,177.9,167.43,177.85,168.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.23,163.64l-9.92,3.57a4.37,4.37,0,0,1,1.95.91c.1.09,8-2.62,8-2.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.28 166.66 172.29 172.72 167.7 174.34 167.28 166.66",
    style: {
      fill: "#9c5c5c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.28 166.66 172.29 172.72 167.7 174.34 167.28 166.66",
    style: {
      fill: "#803e3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.22,167.42a1.36,1.36,0,0,0,1.36,1.38,1.38,1.38,0,1,0,0-2.75A1.37,1.37,0,0,0,160.22,167.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.76,167a1.37,1.37,0,0,0,1.36,1.39,1.39,1.39,0,0,0,1.39-1.37,1.38,1.38,0,0,0-2.75,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,161l3.68.41a2,2,0,0,0-1.54-1.62A2.33,2.33,0,0,0,171,161Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,161.27l-3.71,0a2,2,0,0,1,1.73-1.42A2.33,2.33,0,0,1,163,161.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.41,176.77l5.29,1.63a3.26,3.26,0,0,1-3.56,1.64C162.84,179.68,162.25,178.11,162.41,176.77Z",
    style: {
      fill: "#9c5c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.41,176.77l5.29,1.63a3.26,3.26,0,0,1-3.56,1.64C162.84,179.68,162.25,178.11,162.41,176.77Z",
    style: {
      fill: "#5e2828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.87,179.93a3,3,0,0,1-1.73.11,2.65,2.65,0,0,1-1.72-2.39,3,3,0,0,1,3.45,2.28Z",
    style: {
      fill: "#9c5c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.87,179.93a3,3,0,0,1-1.73.11,2.65,2.65,0,0,1-1.72-2.39,3,3,0,0,1,3.45,2.28Z",
    style: {
      fill: "#803e3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.43,199.27c-4.82-.08-5.52,7.71-9.92,9l-11.22-13.65,3.48-5.17a9,9,0,0,1,2.65-2.57h0l0,1.87a3.22,3.22,0,0,0,1.59,2.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.43,199.27c2.67-.83,6.67,2.51,6.67,2.51-1.4-7.74-5.64-14.88-6.67-14.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.55,101.73c1.45-.84,2.35-.5,2.36.88a4.33,4.33,0,0,1-2.34,3.59l-.92.53v1.59l-1.5.86v-6.06Zm-.07,3.17a1.63,1.63,0,0,0,.92-1.41c0-.56-.31-.72-.93-.36l-.83.48v1.77l.83-.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.36,102l1.15,1.25-1.6.92-1-1.06-.81.47v1.61l-1.5.87,0-6.07L167,98.56c1.44-.83,2.34-.49,2.35.89A3.8,3.8,0,0,1,168.36,102Zm-1.4-.22a1.65,1.65,0,0,0,.92-1.42c0-.56-.31-.71-.93-.36l-.83.48v1.78l.83-.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.86,95.07c1.69-1,2.94-.35,2.95,1.46a6,6,0,0,1-2.93,4.85c-1.68,1-2.93.36-2.94-1.46A6.05,6.05,0,0,1,172.86,95.07Zm0,4.89a3.08,3.08,0,0,0,1.42-2.56c0-1-.63-1.37-1.43-.9A3.06,3.06,0,0,0,171.45,99c0,1.06.63,1.38,1.43.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.72 90.66 180.73 91.98 178.08 93.51 178.09 94.84 180.42 93.5 180.42 94.83 178.09 96.17 178.1 98.25 176.6 99.11 176.59 93.05 180.72 90.66",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.92 89.39 182.94 95.45 181.44 96.32 181.43 90.25 182.92 89.39",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.47 87.92 185.49 92.62 188 91.17 188.01 92.53 184 94.84 183.98 88.78 185.47 87.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.72 83.73 192.72 85.06 190.06 86.59 190.07 87.61 192.41 86.26 192.41 87.54 190.07 88.89 190.07 90 192.83 88.42 192.83 89.74 188.6 92.19 188.58 86.12 192.72 83.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.34,80.49c1.75-1,2.94-.53,2.95,1.33a5.66,5.66,0,0,1-2.94,4.73L195.86,88l0-6.06Zm-.05,4.73a3,3,0,0,0,1.5-2.53c0-1-.61-1.31-1.51-.79l-.94.54v3.32l.94-.54",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.16,76.55l2.35,4.71-1.55.9-.42-.94-2.23,1.29-.41,1.42-1.52.88,2.31-7.41ZM203.75,81l1.35-.78-.68-1.55L203.75,81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.35,70.67l2.35,4.71-1.55.9-.42-.94-2.23,1.29-.41,1.42-1.52.87,2.31-7.4Zm-1.42,4.44,1.36-.78-.69-1.55-.67,2.33",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.88 72.67 211.89 74.03 210.28 74.96 210.29 79.66 208.8 80.52 208.78 75.82 207.17 76.75 207.16 75.39 211.88 72.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.09 107.81 168.09 111.99 210.38 87.58 210.38 83.41 168.09 107.81",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "168.09 107.81 168.09 111.99 210.38 87.58 210.38 83.41 168.09 107.81",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "178.66 109.18 178.66 113.35 203.26 99.07 203.26 94.9 178.66 109.18",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "178.66 109.18 178.66 113.35 203.26 99.07 203.26 94.9 178.66 109.18",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "191.62 135.97 191.62 140.14 249.56 106.74 249.56 102.57 191.62 135.97",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.62 143.12 191.62 147.29 236.68 121.33 236.68 117.16 191.62 143.12",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.62 155.8 191.62 159.97 249.56 126.58 249.56 122.41 191.62 155.8",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.62 162.96 191.62 167.13 249.56 133.77 249.56 129.6 191.62 162.96",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.62 169.87 191.62 174.04 235.32 148.94 235.32 144.77 191.62 169.87",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.62 112.01 191.62 119.15 233.91 94.75 233.91 87.61 191.62 112.01",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.62 122.81 191.62 127.3 219.72 111.16 219.72 106.67 191.62 122.81",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "191.62 135.97 191.62 140.14 249.56 106.74 249.56 102.57 191.62 135.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.62 143.12 191.62 147.29 236.68 121.33 236.68 117.16 191.62 143.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.62 155.8 191.62 159.97 249.56 126.58 249.56 122.41 191.62 155.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.62 162.96 191.62 167.13 249.56 133.77 249.56 129.6 191.62 162.96",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.62 169.87 191.62 174.04 235.32 148.94 235.32 144.77 191.62 169.87",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.62 112.01 191.62 119.15 233.91 94.75 233.91 87.61 191.62 112.01",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.62 122.81 191.62 127.3 219.72 111.16 219.72 106.67 191.62 122.81",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "195.6 178.47 196.91 180.76 199.83 179.56 197.73 183.15 198.23 186.2 195.62 186.13 193.01 189.22 193.5 185.59 191.38 184.44 194.3 182.27 195.6 178.47",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.27 171.16 209.58 173.45 212.5 172.25 210.39 175.84 210.9 178.89 208.29 178.82 205.68 181.9 206.17 178.27 204.05 177.13 206.96 174.96 208.27 171.16",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.93 163.84 222.25 166.13 225.16 164.93 223.06 168.52 223.57 171.57 220.96 171.5 218.34 174.59 218.84 170.96 216.71 169.81 219.63 167.64 220.93 163.84",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.6 156.53 234.91 158.82 237.83 157.62 235.73 161.21 236.24 164.26 233.62 164.19 231.01 167.28 231.5 163.65 229.38 162.5 232.31 160.33 233.6 156.53",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.27 149.22 247.58 151.51 250.5 150.31 248.4 153.9 248.91 156.94 246.29 156.88 243.68 159.96 244.17 156.33 242.05 155.19 244.97 153.01 246.27 149.22",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.6 189.52 196.91 191.81 199.83 190.6 197.73 194.19 198.23 197.25 195.62 197.18 193.01 200.26 193.5 196.64 191.38 195.49 194.3 193.32 195.6 189.52",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.27 182.2 209.58 184.49 212.5 183.29 210.39 186.88 210.9 189.94 208.29 189.86 205.68 192.95 206.17 189.32 204.05 188.17 206.96 186 208.27 182.2",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.93 174.89 222.25 177.18 225.16 175.98 223.06 179.57 223.57 182.62 220.96 182.55 218.34 185.63 218.84 182.01 216.71 180.86 219.63 178.69 220.93 174.89",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.6 167.58 234.91 169.87 237.83 168.67 235.73 172.26 236.24 175.3 233.62 175.24 231.01 178.32 231.5 174.69 229.38 173.54 232.31 171.37 233.6 167.58",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.27 160.26 247.58 162.55 250.5 161.35 248.4 164.94 248.91 167.99 246.29 167.92 243.68 171.01 244.17 167.38 242.05 166.23 244.97 164.06 246.27 160.26",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.6 200.56 196.91 202.85 199.83 201.65 197.73 205.24 198.23 208.29 195.62 208.22 193.01 211.31 193.5 207.68 191.38 206.53 194.3 204.36 195.6 200.56",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.27 193.25 209.58 195.54 212.5 194.34 210.39 197.93 210.9 200.98 208.29 200.91 205.68 203.99 206.17 200.37 204.05 199.22 206.96 197.05 208.27 193.25",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.93 185.94 222.25 188.23 225.16 187.03 223.06 190.62 223.57 193.66 220.96 193.6 218.34 196.68 218.84 193.05 216.71 191.9 219.63 189.74 220.93 185.94",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.6 178.62 234.91 180.91 237.83 179.71 235.73 183.3 236.24 186.35 233.62 186.28 231.01 189.37 231.5 185.74 229.38 184.59 232.31 182.42 233.6 178.62",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.27 171.31 247.58 173.6 250.5 172.4 248.4 175.99 248.91 179.04 246.29 178.97 243.68 182.06 244.17 178.43 242.05 177.28 244.97 175.1 246.27 171.31",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "195.6 178.47 196.91 180.76 199.83 179.56 197.73 183.15 198.23 186.2 195.62 186.13 193.01 189.22 193.5 185.59 191.38 184.44 194.3 182.27 195.6 178.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.27 171.16 209.58 173.45 212.5 172.25 210.39 175.84 210.9 178.89 208.29 178.82 205.68 181.9 206.17 178.27 204.05 177.13 206.96 174.96 208.27 171.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.93 163.84 222.25 166.13 225.16 164.93 223.06 168.52 223.57 171.57 220.96 171.5 218.34 174.59 218.84 170.96 216.71 169.81 219.63 167.64 220.93 163.84",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "195.6 189.52 196.91 191.81 199.83 190.6 197.73 194.19 198.23 197.25 195.62 197.18 193.01 200.26 193.5 196.64 191.38 195.49 194.3 193.32 195.6 189.52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.27 182.2 209.58 184.49 212.5 183.29 210.39 186.88 210.9 189.94 208.29 189.86 205.68 192.95 206.17 189.32 204.05 188.17 206.96 186 208.27 182.2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.93 174.89 222.25 177.18 225.16 175.98 223.06 179.57 223.57 182.62 220.96 182.55 218.34 185.63 218.84 182.01 216.71 180.86 219.63 178.69 220.93 174.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.6 167.58 234.91 169.87 237.83 168.67 235.73 172.26 236.24 175.3 233.62 175.24 231.01 178.32 231.5 174.69 229.38 173.54 232.31 171.37 233.6 167.58",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "195.6 200.56 196.91 202.85 199.83 201.65 197.73 205.24 198.23 208.29 195.62 208.22 193.01 211.31 193.5 207.68 191.38 206.53 194.3 204.36 195.6 200.56",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.27 193.25 209.58 195.54 212.5 194.34 210.39 197.93 210.9 200.98 208.29 200.91 205.68 203.99 206.17 200.37 204.05 199.22 206.96 197.05 208.27 193.25",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.93 185.94 222.25 188.23 225.16 187.03 223.06 190.62 223.57 193.66 220.96 193.6 218.34 196.68 218.84 193.05 216.71 191.9 219.63 189.74 220.93 185.94",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "142.33 246.77 127.39 255.44 127.39 272.73 139.73 265.59 142.33 260.22 142.33 246.77",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.33 246.77 127.39 255.44 127.39 272.73 139.73 265.59 142.33 260.22 142.33 246.77",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.73 265.59 142.33 260.22 139.73 261.72 139.73 265.59",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.73 265.59 142.33 260.22 139.73 261.72 139.73 265.59",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.38 245.03 145.38 248.68 186.16 225.16 186.16 221.51 145.38 245.03",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.38 251.29 145.38 254.94 186.16 231.45 186.16 227.8 145.38 251.29",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.38 257.33 145.38 260.98 173.71 244.72 173.71 241.07 145.38 257.33",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "145.38 245.03 145.38 248.68 186.16 225.16 186.16 221.51 145.38 245.03",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.38 251.29 145.38 254.94 186.16 231.45 186.16 227.8 145.38 251.29",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.38 257.33 145.38 260.98 173.71 244.72 173.71 241.07 145.38 257.33",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "142.33 269.98 127.39 278.64 127.39 295.94 139.73 288.79 142.33 283.42 142.33 269.98",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.33 269.98 127.39 278.64 127.39 295.94 139.73 288.79 142.33 283.42 142.33 269.98",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.73 288.79 142.33 283.42 139.73 284.93 139.73 288.79",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.73 288.79 142.33 283.42 139.73 284.93 139.73 288.79",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.38 268.24 145.38 271.89 186.61 248.12 186.61 244.47 145.38 268.24",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.38 274.5 145.38 278.14 186.61 254.41 186.61 250.76 145.38 274.5",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.38 280.54 145.38 284.19 154.31 279.16 154.31 275.51 145.38 280.54",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "145.38 268.24 145.38 271.89 186.61 248.12 186.61 244.47 145.38 268.24",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.38 274.5 145.38 278.14 186.61 254.41 186.61 250.76 145.38 274.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.38 280.54 145.38 284.19 154.31 279.16 154.31 275.51 145.38 280.54",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "142.33 293.19 127.39 301.85 127.39 319.14 139.73 312 142.33 306.63 142.33 293.19",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.33 293.19 127.39 301.85 127.39 319.14 139.73 312 142.33 306.63 142.33 293.19",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.73 312 142.33 306.63 139.73 308.13 139.73 312",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.73 312 142.33 306.63 139.73 308.13 139.73 312",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.38 291.45 145.38 295.09 187 270.93 187 267.28 145.38 291.45",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.38 297.7 145.38 301.35 187 277.22 187 273.57 145.38 297.7",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.38 303.74 145.38 307.39 187 283.31 187 279.66 145.38 303.74",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "145.38 291.45 145.38 295.09 187 270.93 187 267.28 145.38 291.45",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.38 297.7 145.38 301.35 187 277.22 187 273.57 145.38 297.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.38 303.74 145.38 307.39 187 283.31 187 279.66 145.38 303.74",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M248.87,253l-55.55,32a1.08,1.08,0,0,1-1.63-.94V221.41a3.26,3.26,0,0,1,1.63-2.83l55.55-32.06a1.09,1.09,0,0,1,1.63.95v62.67A3.26,3.26,0,0,1,248.87,253Z",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.4 213.48 196.46 222.15 196.46 239.44 208.81 232.3 211.4 226.93 211.4 213.48",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.4 213.48 196.46 222.15 196.46 239.44 208.81 232.3 211.4 226.93 211.4 213.48",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.81 232.3 211.4 226.93 208.81 228.43 208.81 232.3",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.81 232.3 211.4 226.93 208.81 228.43 208.81 232.3",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.93 213.85 214.93 216.28 247.25 197.63 247.25 195.2 214.93 213.85",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.93 220.44 247.25 201.81 247.25 199.38 214.93 218.01 214.93 220.44",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.93 224.73 247.25 206.08 247.25 203.66 214.93 222.31 214.93 224.73",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.57 216.28 214.93 226.47 214.93 228.9 232.57 218.7 232.57 216.28",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.46 245.6 247.25 216.4 247.25 213.98 196.46 243.17 196.46 245.6",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.14 225.71 196.46 247.34 196.46 249.76 234.14 228.14 234.14 225.71",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.46 265.25 247.25 236.05 247.25 233.63 196.46 262.82 196.46 265.25",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.68 250.79 196.46 266.98 196.46 269.41 224.68 253.21 224.68 250.79",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.46 273.7 247.25 244.51 247.25 242.08 196.46 271.28 196.46 273.7",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.46 277.87 221.86 263.28 221.86 260.85 196.46 275.44 196.46 277.87",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.36 261.26 233.32 256.69 233.32 254.26 225.36 258.84 225.36 261.26",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.46 254.06 247.25 224.86 247.25 222.44 196.46 251.63 196.46 254.06",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.18 245.61 196.46 255.79 196.46 258.22 214.18 248.04 214.18 245.61",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "214.93 213.85 214.93 216.28 247.25 197.63 247.25 195.2 214.93 213.85",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.93 220.44 247.25 201.81 247.25 199.38 214.93 218.01 214.93 220.44",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.93 224.73 247.25 206.08 247.25 203.66 214.93 222.31 214.93 224.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.57 216.28 214.93 226.47 214.93 228.9 232.57 218.7 232.57 216.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.46 245.6 247.25 216.4 247.25 213.98 196.46 243.17 196.46 245.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.14 225.71 196.46 247.34 196.46 249.76 234.14 228.14 234.14 225.71",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.46 265.25 247.25 236.05 247.25 233.63 196.46 262.82 196.46 265.25",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.68 250.79 196.46 266.98 196.46 269.41 224.68 253.21 224.68 250.79",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.46 273.7 247.25 244.51 247.25 242.08 196.46 271.28 196.46 273.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.46 277.87 221.86 263.28 221.86 260.85 196.46 275.44 196.46 277.87",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.36 261.26 233.32 256.69 233.32 254.26 225.36 258.84 225.36 261.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.46 254.06 247.25 224.86 247.25 222.44 196.46 251.63 196.46 254.06",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.18 245.61 196.46 255.79 196.46 258.22 214.18 248.04 214.18 245.61",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-164"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.56,404.17a11.38,11.38,0,0,0,8.55,3.15,25.79,25.79,0,0,0,9.05-2.28c2.89-1.19,6.52-4.52,9.65-4.46A75.46,75.46,0,0,0,303,400a48.07,48.07,0,0,0-1.3-12.39l-14.6-.39c-3.94,5.4-11.61,9.89-17.41,11.58a5.1,5.1,0,0,0-3.6,3.84.28.28,0,0,0,0,.09A6,6,0,0,0,266.56,404.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.81,400.58c-3.13-.06-6.76,3.27-9.65,4.46a25.79,25.79,0,0,1-9.05,2.28,11.38,11.38,0,0,1-8.55-3.15,6,6,0,0,1-.5-1.48.28.28,0,0,1,0-.09,4.54,4.54,0,0,0,0,1.94,6,6,0,0,0,.5,1.49,11.41,11.41,0,0,0,8.55,3.14,25.79,25.79,0,0,0,9.05-2.28c2.89-1.19,6.52-4.52,9.65-4.46a66,66,0,0,0,9-.52c.08-.65.12-1.3.15-2A75.46,75.46,0,0,1,293.81,400.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.79,412.31a22.25,22.25,0,0,1-.47,4.75A11,11,0,0,1,334,424a14,14,0,0,1-6.91,1.83,15.26,15.26,0,0,1-6.31-.65,7.18,7.18,0,0,1-3.7-3s0,.06,0,.08a6.6,6.6,0,0,0,4.25,4.43,15.31,15.31,0,0,0,6.32.65,13.92,13.92,0,0,0,6.9-1.83,11,11,0,0,0,4.34-6.93,22.25,22.25,0,0,0,.47-4.75,8.05,8.05,0,0,1,2.55-5.81,15,15,0,0,0,1.11-1.15,2.79,2.79,0,0,0,.68-2.07q0-.43-.09-.87c-.58.68-1.93,2.28-2.27,2.6A8.05,8.05,0,0,0,338.79,412.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.81,395.75a17.41,17.41,0,0,1-1.22,9.63,36.76,36.76,0,0,1-5.1,8.39,25.07,25.07,0,0,0-2.67,3.89,7,7,0,0,0-.76,4.49,7.18,7.18,0,0,0,3.7,3,15.26,15.26,0,0,0,6.31.65A14,14,0,0,0,334,424a11,11,0,0,0,4.34-6.93,22.25,22.25,0,0,0,.47-4.75,8.05,8.05,0,0,1,2.55-5.81c.34-.32,1.69-1.92,2.27-2.6a17.66,17.66,0,0,0-2.35-6.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.15,259.18s-3.88,48.5-3.54,62,1.76,66.8,1.76,66.8c7.93,4.42,19.39,1.13,19.39,1.13.93-42.56,5.14-51.71,2.28-67.29,2-11.56,4.81-38.51,4.81-38.51,3.95,32.41,6.82,49.11,6.82,49.11l9.44,64.88c7.75,3.85,17.53,0,17.53,0,0-37,.84-52.63-3.21-77a535,535,0,0,0-4-64.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.52,271.71c2.71,6.31,11.19,6.31,11.19,6.31l1.52,7.19-.57,25.54c1.63-12.42,3.19-27.45,3.19-27.45l-1.05-7.68A23.24,23.24,0,0,1,294.52,271.71Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.09,184c-13.25,0-15.42,5.15-18.77,13.69s-5.94,23.79-5.94,23.79l12.81-2.76,5-28.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.19,216.63a20.24,20.24,0,0,0-9.76,1.77,8,8,0,0,0-3.13,2.25,3.62,3.62,0,0,0-.54,3.66c-1.22,2.24-1.11,5.57-.86,8.31a4.67,4.67,0,0,0,.34,1.54,1.78,1.78,0,0,0,1.14,1l12.81-11.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.8,219.47c-4.55-.36-7.84,2.26-9.32,3.6a3,3,0,0,0,.28,1.24C273.81,222.72,278.28,219.83,281.8,219.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.83,223.81a18.43,18.43,0,0,1,9.36-2.46v-1.06A15,15,0,0,0,276.83,223.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.21,175.13h0Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.81,184.84l-6.22-.66-30.5-.21c-10.69,0-12.06,13.15-12.67,24.79s1.35,35.05-1.3,50.69l12.73,8.22,3.57-3.85,5.7,5.31c19.35,0,30.75-10.74,32.2-12.59Z",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.81,184.84l-6.22-.66-30.5-.21c-10.69,0-12.06,13.15-12.67,24.79s1.35,35.05-1.3,50.69l12.73,8.22,3.57-3.85,5.7,5.31c19.35,0,30.75-10.74,32.2-12.59Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.07,188c-2.85,9.08-1.06,21.74,0,27.43,7.23-9.93,14-19.9,16.11-23.8l-10.08-4.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.11,216.13l-3.28,4.4a6.37,6.37,0,0,0-1.25,4.19l2.2,36.59L296,225a6.35,6.35,0,0,1,2.17-5.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.81,184.84l4.14.66a12.18,12.18,0,0,1,10,9.59,145.42,145.42,0,0,1,2.69,35.11l-18.88-8.7C330.74,206.74,326.86,194.55,334.81,184.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.1,222.07a1.33,1.33,0,0,1,1.35-1.33c8.55.11,16.85,4.18,19.12,9a7.07,7.07,0,0,1,0,4.62c1.52,2,.73,3-.07,4.43s.4,4.67-2.18,4.52l.6-1.23c-5.11-9.91-18-14-18-14l-.07-1.64a1.12,1.12,0,0,0-.38-.78h0a1.13,1.13,0,0,1-.37-.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.77,226.15a29.11,29.11,0,0,1,10.8,8.17,8.5,8.5,0,0,0,.35-1.55C351.5,231,348.43,227.74,341.77,226.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.15,225.13a1.19,1.19,0,0,0,.32.51,1.12,1.12,0,0,1,.38.78v.13a28.46,28.46,0,0,1,15.78,8C344.68,228.82,336,225.88,332.15,225.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.92,228.06l-.07-1.51c-14.48-5-40-4-47.48-4.1-5.5,0-13.19,8.79-12.62,12.27s.63,6.47,7.35,7c4.75.3,13.9-1.52,13.9-1.52,25.23,7.75,49.57,6.38,53.34,5.69,1.8-.26,3-2.66,3-2.66l.6-1.23C345.81,232.13,332.92,228.06,332.92,228.06Z",
    style: {
      fill: "#9c5c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.5,235.24a11,11,0,0,0-1.79-3.48,38.75,38.75,0,0,0-7.79-3.7l-.07-1.51-.94-.31.19,1.87c-4.12.28-28.27,10.16-38.1,12.13,1.93.59,3.84,1.12,5.74,1.61,11-3.81,26.12-11.31,33.11-12.39C337.72,230.71,340.22,232,342.5,235.24Z",
    style: {
      fill: "#803e3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.43,157.7c1.51-5.06,1.18-10.88-1.85-15.21a16.51,16.51,0,0,0-8-5.92,25.4,25.4,0,0,0-10-1.29,18.4,18.4,0,0,0-7.7,1.85,12.4,12.4,0,0,0-5.09,16.8,20.65,20.65,0,0,0,5,5.75,64.36,64.36,0,0,0,12.7,8.48c1.14.58,2.3,1.12,3.47,1.63.79.35,2.3,1.33,3.19,1.15s1.83-1.85,2.37-2.53c.77-1,1.52-2,2.2-3A29.41,29.41,0,0,0,330.43,157.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.28,196.36l-2.48-.59a81.68,81.68,0,0,0-3,9.72,96,96,0,0,0,1.31,10c1.42-1.95,2.82-3.89,4.17-5.8A66.23,66.23,0,0,1,307.28,196.36Z",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.23,196.89c0-.18,0-.36,0-.53l-2.48-.59s-.06.14-.14.37a3.15,3.15,0,0,0,1.41.74A3.23,3.23,0,0,0,307.23,196.89Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.62,189.85l2-1.26,4.56,2.48a10.49,10.49,0,0,1-5.38,2.14Z",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.6,189.36,305,188l-2.3,1.44a4.18,4.18,0,0,0,1.5,2.19Z",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.62,189.85l2-1.26,4.56,2.48a10.49,10.49,0,0,1-5.38,2.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.6,189.36,305,188l-2.3,1.44a4.18,4.18,0,0,0,1.5,2.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.76,193.21a11,11,0,0,0-1.14-3.36l-3-.49a11.71,11.71,0,0,0-1.4,2.29,10.86,10.86,0,0,0,.6,4.12,5.26,5.26,0,0,0,2.48.59A6.53,6.53,0,0,0,309.76,193.21Z",
    style: {
      fill: "#AF7A19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.53,166.49V180.3c-2.75,3.79-14.3,8.6-15,8.48-.84-.14,0-7.58,0-8.23V175c2.24-.34,4.45-.73,6.43-1.15A11.67,11.67,0,0,0,322.53,166.49Z",
    style: {
      fill: "#9c5c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.59,177.08a32.9,32.9,0,0,1-5,.89v-3c2.24-.34,4.45-.73,6.43-1.15a11.63,11.63,0,0,0,8.25-6.67,12,12,0,0,1-3,6.23A14.42,14.42,0,0,1,312.59,177.08Z",
    style: {
      fill: "#803e3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.93,144.74a12.67,12.67,0,0,0,8.4,3.54c3,0,5.82-.95,8.67-1.73a6.7,6.7,0,0,0,2,3.62,7.66,7.66,0,0,0,4,1.76,25.87,25.87,0,0,0,0,8,1.51,1.51,0,0,0,1,1.24c1,.28,1.6-.7,2.06-1.5a6.49,6.49,0,0,1,2.09-2.32,3.19,3.19,0,0,1,3-.31,3.13,3.13,0,0,1,1.59,1.93,5.82,5.82,0,0,1,.13,2.56,7.75,7.75,0,0,1-1.66,3.9,5.29,5.29,0,0,1-3.71,1.91,3.82,3.82,0,0,1-3.56-1.76l-.07.26a8.52,8.52,0,0,1-.39,1.24,10.64,10.64,0,0,1-7.78,6.67c-1.81.38-3.82.74-5.86,1-1,.15-2,.3-3,.42a7.29,7.29,0,0,1-8.05-6C296.43,161.52,296,152.45,298.93,144.74Z",
    style: {
      fill: "#9c5c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.48,153.34v1.84l.45.26a19.89,19.89,0,0,1,.42,3.63,5.07,5.07,0,0,0,1.26,3.22,4.87,4.87,0,0,0,3.37.93,5.94,5.94,0,0,0,2.81-.43,4.78,4.78,0,0,0,2.14-2.75c.41-1.15.34-1.82.84-3.21a.94.94,0,0,1,.9-.64,1,1,0,0,1,1,.64c.53,1.39.46,2.06.89,3.21a4.86,4.86,0,0,0,2.29,2.75,6.81,6.81,0,0,0,3,.43,5.46,5.46,0,0,0,3.6-.93,4.83,4.83,0,0,0,1.34-3.22,19.07,19.07,0,0,1,.45-3.63l.49-.26v-1.84a12.84,12.84,0,0,0-12.12,1.23h-1.76A11.36,11.36,0,0,0,293.48,153.34Zm14,1.81a11.77,11.77,0,0,1,6.19-1.8,11.48,11.48,0,0,1,3.07.42c.08,1.4.13,3.34.07,4.22,0,.32,0,.64-.07.95a3.82,3.82,0,0,1-1,2.57,4.64,4.64,0,0,1-3,.72h-.4a5,5,0,0,1-2.15-.35,3.94,3.94,0,0,1-1.82-2.21,15.78,15.78,0,0,1-.88-3.49l-.07-.66S307.43,155.21,307.53,155.15Zm-12.27-1.38a10.14,10.14,0,0,1,2.88-.42,10.44,10.44,0,0,1,5.78,1.8c.1.06.07.37.07.37l-.06.66a16.6,16.6,0,0,1-.83,3.49,3.88,3.88,0,0,1-1.7,2.21,4.38,4.38,0,0,1-2,.35H299a4.13,4.13,0,0,1-2.79-.72,3.92,3.92,0,0,1-1-2.57c0-.31,0-.63-.07-.95C295.14,157.11,295.19,155.17,295.26,153.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.7,153.34l9.87,3.55a4.18,4.18,0,0,0-1.93.9c-.11.09-7.94-2.61-7.94-2.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.71 156.34 300.73 162.37 305.3 163.98 305.71 156.34",
    style: {
      fill: "#9c5c5c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.71 156.34 300.73 162.37 305.3 163.98 305.71 156.34",
    style: {
      fill: "#803e3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.74,157.09a1.37,1.37,0,1,1-1.37-1.36A1.36,1.36,0,0,1,312.74,157.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.26,156.72a1.37,1.37,0,1,1-1.38-1.36A1.37,1.37,0,0,1,301.26,156.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,150.65l-3.66.42a2,2,0,0,1,1.54-1.62A2.3,2.3,0,0,1,302,150.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,151l3.68,0a1.93,1.93,0,0,0-1.72-1.41A2.3,2.3,0,0,0,310,151Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.56,166.4,305.3,168a3.24,3.24,0,0,0,3.54,1.63C310.13,169.3,310.72,167.73,310.56,166.4Z",
    style: {
      fill: "#9c5c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.56,166.4,305.3,168a3.24,3.24,0,0,0,3.54,1.63C310.13,169.3,310.72,167.73,310.56,166.4Z",
    style: {
      fill: "#5e2828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.12,169.55a3,3,0,0,0,1.72.1,2.64,2.64,0,0,0,1.71-2.38,3.19,3.19,0,0,0-2,.37A3.12,3.12,0,0,0,307.12,169.55Z",
    style: {
      fill: "#9c5c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.12,169.55a3,3,0,0,0,1.72.1,2.64,2.64,0,0,0,1.71-2.38,3.19,3.19,0,0,0-2,.37A3.12,3.12,0,0,0,307.12,169.55Z",
    style: {
      fill: "#803e3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.56,188.78c4.79-.08,7.72,3.74,12.1,5l8.93-9.64L325.13,179a8.92,8.92,0,0,0-2.64-2.55h0l0,1.86a3.17,3.17,0,0,1-1.58,2.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.56,188.78c-2.66-.82-6.64,2.51-6.64,2.51,1.39-7.71,5.6-10.74,6.63-10.74Z",
    style: {
      fill: "#37474f"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.ab4a618fcf1f6c9ce1d0df9f9da276d3.svg";
export { ForwardRef as ReactComponent };